import { render, staticRenderFns } from "./ReportMenuHistoryItem.vue?vue&type=template&id=31ea0984&"
import script from "./ReportMenuHistoryItem.vue?vue&type=script&lang=js&"
export * from "./ReportMenuHistoryItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports